import Events from "@wwdev/bootstrap/Events";

class Indicator {
	constructor() {
		this.init();
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		$(document).off('.indicator').on('click.indicator', '.toggle-shop-popup', this.togglePopup.bind(this));
		Events.on('wwdev.winkelwagen.indicator.refresh', this.refreshIndicator.bind(this))
	}

	togglePopup(event) {
		event.preventDefault();
		$('body').toggleClass('shop-popup-open');
	}

	refreshIndicator() {
		let $urlInput = $('[data-winkelwagen-url]');
		let $treeInput = $('[data-tree-id]');
		if ($urlInput.length < 1) {
			return;
		}
		let url = $urlInput.val();
		$.ajax({
			url: url,
			method: 'post',
			data: {
				'action': 'indicator',
				'tree': $treeInput.val()
			},
			success: (response) => {
				$('[data-indicator]').each((index, element) => {
					$(element).html(response.html);
				});
			}
		});
	}
}

export default new Indicator;